export default __webpack_public_path__ + "static/media/vegetarian-cheese.32286d05.jpg";